import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const STypography = withStyles(Typography, {
  root: {
    fontFamily: `'Poppins-Bold', sans-serif`,
  },
});

export { STypography };
